export const CHECKOUT_STARTED = 'Checkout - Started';
export const CHECKOUT_SUBSCRIPTION_TYPE_SELECTED =
  'Checkout - Subscription Type Selected';
export const CHECKOUT_DURATION_SELECTED = 'Checkout - Duration Selected';
export const CHECKOUT_REFERRAL_CODE_APPLIED =
  'Checkout - Referral Code Applied';
export const CHECKOUT_PROCEED_TO_PAYMENT_SELECTED =
  'Checkout - Proceed To Payment Selected';
export const CHECKOUT_CBT_USER_DETAILS_SUBMITTED =
  'Checkout - CBT User Details Submitted';
export const PLAN_SELECTION_PAGE_LOADED = 'Plan Selection page Loaded';
export const CHECKOUT_CREDITS_REDEEMED = 'Checkout - Credits Redeemed';
export const CHECKOUT_CHANGE_DURATION = 'Checkout - Change Duration';
export const CHECKOUT_PIP_SELECTED = 'Checkout - PIP - Pay In Parts Selected';
export const CHECKOUT_PIP_FAQS_CLICKED =
  'Checkout - PIP - Part Payment FAQs Clicked';
export const CHECKOUT_PIP_NO_OF_PARTS_SELECTED =
  'Checkout - PIP - Number Of Parts Selected';
export const CHECKOUT_ORDER_CREATED = 'Checkout - Order Created';
export const CHECKOUT_CASH_PAYMENT_SELECTED =
  'Checkout - Cash Payment Selected';
export const CHECKOUT_BANK_LOCATOR = 'Checkout - Icici Bank Locator';
export const CHECKOUT_GENERATE_CASH_RECEIPT =
  'Checkout - Generate Receipt Clicked';
export const CHECKOUT_RECEIPT_GENERATED = 'Checkout - Receipt Generated';
export const CHECKOUT_DOWNLOAD_RECEIPT = 'Checkout - Download Receipt Clicked';
export const CHECKOUT_RETURN_HOME = 'Checkout - Pay At Bank Selected';
export const CHECKOUT_CASH_PAYMENT_CANCELLED =
  'Checkout - Cash Payment Cancelled';
export const CHECKOUT_COMBO_GOAL_ADDED = 'Checkout - Combo Goal Added';
export const CHECKOUT_COMBO_GOAL_REMOVED = 'Checkout - Combo Goal Removed';
export const CHECKOUT_OFFER_CLAIMED = 'Checkout - Offer Claimed';
export const CHECKOUT_OFFER_FAQS_VIEWED = 'Checkout - Offers FAQs Viewed';
export const CHECKOUT_LOAN_REQ_CLICKED = 'Checkout - Loan Request Clicked';
export const CHECKOUT_LOAN_REQ_SUBMITTED = 'Checkout - Loan Request Submitted';
export const CHECKOUT_PAYMENT_PAGE_LOGGEDIN =
  'Checkout - Payment Page Loggedin';
export const REFER_LINK_CLICKED = 'Refer - Referral Link Clicked';
export const CHECKOUT_REFERRAL_CODE_STARTED =
  'Checkout - Referral Code Started';
export const CHECKOUT_TRIAL_PAYMENT_PAGE_LOGGEDIN =
  'Checkout - Trial Payment Page Loggedin';
export const CHECKOUT_TRIAL_ORDER_CREATED = 'Checkout - Trial Order Created';
export const CHECKOUT_PRIME_PAYMENT_PAGE_LOGGEDIN =
  'Checkout - Prime Payment Page Loggedin';
export const CHECKOUT_PRIME_ORDER_CREATED = 'Checkout - Prime Order Created';
export const PRIME_PITCH_DISPLAYED = 'Prime - Pitch Displayed';
export const PRIME_PITCH_DISMISSED = 'Prime - Pitch Dismissed';
export const CHECKOUT_PRIME_STARTED = 'Checkout - Prime Started';
export const CHECKOUT_PRIME_REFERRAL_CODE_STARTED =
  'Checkout - Prime Referral Code Started';
export const CHECKOUT_PRIME_REFERRAL_CODE_APPLIED =
  'Checkout - Prime Referral Code Applied';
export const CHECKOUT_PRIME_REFERRAL_CODE_FAILED =
  'Checkout - Prime Referral Code Failed';
export const CHECKOUT_PRIME_PAYMENT_PROCEED_PAYMENT =
  'Checkout - Prime Payment Proceed Payment';
